module.exports = __webpack_public_path__ + "img/543504687.ab878f28.jpg";